<template>
	<div class="container-fluid">
		<service-toolbar></service-toolbar>

		<job-messages></job-messages>
	</div>
</template>
<script type="text/javascript">
import JobMessages from "../JobMessages"
import ServiceToolbar from "./ServiceToolbar"
import ServiceMixins from "@/mixins/ServiceMixins.js"
	
export default {
	name: "ServiceMessages",
	components: {
		ServiceToolbar,
		JobMessages
	},
	mixins: [ServiceMixins],
	created() {
		this.setServiceIfNotSet()
	}
}
</script>